import React, { useState, useEffect, useRef } from "react";
import { isRequired } from "../../pages/NewBrief/BriefUtils";
import "./DatePicker.css";
import { Globals } from "../../global/Globals";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";

const DatePickerDropdown = ({
  name,
  placeholderText,
  onDateChange,
  selectedDate,
  minDate = null,
  maxDate = null,
  disabled = false,
  errorMessage = "",
  label,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const currentDate = new Date();
  const minDateallowed = new Date(minDate); // Example minDate

  const yearDiff = currentDate.getFullYear() - minDateallowed.getFullYear();

  // If you want to consider month/day and get a more accurate count:
  const isBefore =
    currentDate.getMonth() < minDateallowed.getMonth() ||
    (currentDate.getMonth() === minDateallowed.getMonth() &&
      currentDate.getDate() < minDateallowed.getDate());

  const accurateYearDiff = yearDiff - (isBefore ? 1 : 0);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const onChange = (date) => {
    onDateChange(name, date);
    setIsOpen(false);
  };

  const onDateContainerClick = (event) => {
    setIsOpen((prev) => !prev);
  };

  return (
    <div className="datepicker-container">
      <div ref={dropdownRef}>
        <div className="datePicker-subcontainer">
          {label && <div className="datepicker-label">{label} :</div>}

          <div
            onClick={!disabled ? onDateContainerClick : null}
            className={`datepicker-date-container ${
              selectedDate ? "brief-date-container-selected" : ""
            }`}
          >
            <label data-placeholder={selectedDate?.toString() || false}>
              {selectedDate
                ? format(new Date(selectedDate), "dd MMM yyyy")
                : placeholderText || "Eg. 28 Feb 2025"}
            </label>
            <img class="dropdown-img" src="/images/calenderIcon.svg"></img>
          </div>
        </div>
        {isOpen && (
          <div className="date-picker">
            <DatePicker
              selected={selectedDate}
              onChange={onChange}
              minDate={minDate}
              maxDate={maxDate}
              disabled={disabled}
              showYearDropdown
              yearDropdownItemNumber={accurateYearDiff}
              dropdownMode="scroll"
              placeholderText="Select a month and year"
              inline
            />
          </div>
        )}

        {!isOpen && !selectedDate && errorMessage && (
          <div>
            <p className="invalidCredential1">
              <img src={Globals.IMG.ERROR} className="errorimg" alt="password error" />
              <span>{errorMessage}</span>
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default DatePickerDropdown;
